module.exports = __webpack_public_path__ + "static/media/animation.d0585010.gif";